import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AddEditFormGeneric } from '../../../../ui/generics';
import { FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../core/services';
import { IEvent, ISeminar } from '../../core/interfaces';
import { SeminarsErrorResolverService, SeminarsEventsService } from '../../core/services';
import * as moment from 'moment';
import { disableDatesBeforeNow } from '../../../../core/configs';

@Component({
    selector: 'app-add-edit-event-form',
    templateUrl: './add-edit-event-form.component.html',
    styleUrls: ['./add-edit-event-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditEventFormComponent extends AddEditFormGeneric<IEvent> implements OnInit {

  @ViewChild('nameInput') nameInput: ElementRef<HTMLInputElement>;

  @Input() seminar: ISeminar;

  public readonly disableDatesBeforeNow = disableDatesBeforeNow;

  constructor(
    protected _fb: FormBuilder,
    protected _service: SeminarsEventsService,
    protected _notifyService: NotificationService,
    protected _errorResolver: SeminarsErrorResolverService,
  ) {
    super(_fb, _service, _notifyService, _errorResolver);
    this.form = this._fb.group({
      orderNumber: ['', Validators.required],
      seats: [15, Validators.required],
      beginning: ['', Validators.required],
      comment: [''],
      leader: [''],
      isInactiveInShopware: false
    });

    this.form.get('orderNumber').disable();
  }

  public get eventDisplayName(): string {
    const title = this.seminar?.name?.trim();
    const beginning = this.form.get('beginning')?.value;
    const location = this.seminar?.category?.name?.trim();
    let when = '';
    if (beginning) {
      const date = moment(beginning).format('DD.MM.YYYY');
      const time = moment(beginning).format('HH:mm');
      when = location ? `${date} um ${time} Uhr in ${location}` : `${date} um ${time} Uhr`;
    }
    if (title && when) {
      return `${title} am ${when}`;
    }
    return title || when || '';
  }

  public override beforeLoadForm(): void {
    if (!this.seminar && this.editObject) {
      this.seminar = this.editObject.seminar;
    }

    super.beforeLoadForm();
  }

  public override saveNew(): void {
    this._service.create(this.data).subscribe(() => {
      this._notifyService.pushSuccess('Erfolgreich', `Element wurde korrekt erstellt`);
      this.formFinished.emit(true);
    }, err => {
      this.parseError(err);
      this.formFinished.emit(false);
    });
  }

  public override saveEdit(): void {
    this._service.update(this.data, this.editObject.id).subscribe(() => {
      this._notifyService.pushSuccess('Erfolgreich', `Element wurde korrekt aktualisiert.`);
      this.formFinished.emit(true);
    }, err => {
      this.parseError(err);
      this.formFinished.emit(false);
    });
  }

  private get data(): object {
    return {
      seminarId: this.seminar.id,
      name: this.nameInput.nativeElement.value,
      comment: this.form.value['comment'],
      beginning: moment(this.form.value['beginning']).format('YYYY-MM-DDTHH:mm:ss'),
      seats: this.form.value['seats'],
      leader: this.form.value['leader'],
      isInactiveInShopware: this.form.value['isInactiveInShopware'],
    };
  }
}
